// 프로젝트 전반에서 사용될 상수들

const ENV = process.env;

export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const BASE_NAME = ENV.REACT_APP_HOST_ROOT;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
export const FILE_URL = `${PUBLIC_URL}/files`;
